import { computed } from "vue";
import { useAuthStoreRefactor } from "@/stores/authStoreRefactor";

/**
 * Who may see AI features. The backend enforces the same rules; this only hides
 * what a user cannot use.
 * - canUseAi: beta_tester for the current tenant (the API only reports roles that
 *   apply to the current tenant)
 * - canManageGuidance / canManageTemplates: admin (templates are shared by all
 *   tenants, so a template change applies everywhere)
 * - canViewGlobalUsage: super_admin (usage of all tenants, aggregates only)
 */
export function useAiAccess() {
  const authStore = useAuthStoreRefactor();
  const roles = computed(() => authStore.user?.roles || []);
  const isAdmin = computed(() => roles.value.includes("admin"));

  return {
    canUseAi: computed(() => roles.value.includes("beta_tester")),
    canManageGuidance: isAdmin,
    canManageTemplates: isAdmin,
    canViewGlobalUsage: computed(() => roles.value.includes("super_admin")),
  };
}
